import {
    Typography,
    Container,
    Grid,
    Card,
    CardHeader,
    Link,
    Stack
} from '@mui/material'

import Iconify from '../components/Iconify';
import BreadcrumbsMenu from '../components/BreadcrumbsMenu';
import IRPCalculatorForm from '../components/IRPCalculator';
import IRPTable from '../components/IRPTable';

import Page from '../components/Page'

export default function IRPCalculatorPage() {

    return (
        <Page title="Calculadora de IRP / IRPF, Renta de Servicios Personales">

            <Container maxWidth="lg" container spacing={1} >
              <br />
              <BreadcrumbsMenu />
              
              <Grid container spacing={3} sx={{pt: 3, pb: 3}}>
                <Grid item xs={12} md={4}>

                  <Card sx={{ p: 2 }} alignItems="left">
                      <CardHeader title="Tabla de Cálculo"/>
                      <IRPTable />
                      <br />
                      <Stack direction="row" alignItems="center">
                        <Iconify icon={'gg:info'} width={16} height={16} />
                        &nbsp;
                        <Typography variant="caption">
                          Puedes encontrar más información&nbsp;
                          <Link underline="hover" 
                                href="https://www.conta.com.py/post/impuesto-a-la-renta-personal-irp-conceptos-basicos" 
                                target="_blank">en este artículo</Link>.
                        </Typography>
                      </Stack>
                      <br />
                      <Stack direction="row" alignItems="center">
                        <Iconify icon={'emojione:warning'} width={16} height={16} />
                        &nbsp;
                        <Typography variant="caption">
                          <strong>Observación</strong>
                        </Typography>
                      </Stack>
                      
                      <Stack direction="row" alignItems="center">
                        <Typography variant="caption">
                          El cálculo del impuesto difiere cuando se adquiere un inmueble para la vivienda al contado cada 5 años a través de un préstamo.
                        </Typography>
                      </Stack>
                  </Card>

                </Grid>
                
                <Grid item xs={12} md={8}>
                  <Card sx={{ pl: 2, pr: 2, pb: 2}} alignItems="center" >
                    
                    <IRPCalculatorForm />
                    
                  </Card>
                </Grid>
              </Grid>
            </Container>
        </Page>
        
    );
}

